import { useMutation } from '@grandvisionhq/graphql';
import { SUBSCRIBE_NEWSLETTER } from '../operations/mutations/subscribe-newsletter.js';

const useSubscribeNewsletter = ()=>{
    const [subscribeNewsletter, { data , error: error1 , loading  }] = useMutation(SUBSCRIBE_NEWSLETTER, {
        onError: (error)=>{
            console.error(`Error occurred while executing the newsletter mutation: ${error}`);
        }
    });
    const { failures , success  } = (data === null || data === void 0 ? void 0 : data.subscribeNewsletter) || {};
    const onSubmit = ({ email , firstName , lastName , mandateText  })=>{
        subscribeNewsletter({
            variables: {
                input: {
                    email,
                    firstName,
                    lastName,
                    mandateText,
                    uiType: 'checkbox',
                    value: true
                }
            }
        });
    };
    return {
        hasError: !!error1 || !!(failures === null || failures === void 0 ? void 0 : failures.length),
        hasSubscribed: success || false,
        isLoading: loading,
        onSubmit
    };
};

export { useSubscribeNewsletter };
//# sourceMappingURL=use-subscribe-newsletter.js.map
